import react from "react";
import Grid from '@mui/material/Grid';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import img from '../../assets/imgs/Session-img.png';
import Buttons from '../Button/Button';
import CourseCard from './CourseCard';
import EmptyCard from '../EmptyCard/EmptyCard';

function AllCourses(props) {

    const { upcommingCourses, inprogressCourses, completedCourses, setUpdateCart, enrollNowHandler } = props;
    
    let allCourses = [];

    if(upcommingCourses?.length > 0){
        allCourses = allCourses.concat(upcommingCourses);
    }
    if(inprogressCourses?.length > 0){
        allCourses = allCourses.concat(inprogressCourses);
    }
    if(completedCourses?.length > 0){
        allCourses = allCourses.concat(completedCourses);
    }
    
    return (
        <div>
            <Grid container spacing={3}>

                {allCourses ? (
                    <CourseCard 
                        courses={allCourses} 
                        setUpdateCart={setUpdateCart} 
                        cardBtn="show" enrollNowHandler={enrollNowHandler}
                        
                    />
                ) : (

                <Grid item xs={12} sm={12} md={12}>
                    <EmptyCard 
                        title="You will find available courses here"
                        Description="Please stay tuned for new courses"
                    />
                </Grid>)}
            </Grid>
        </div>
    );
}

export default AllCourses;
